import { Alert, Typography } from '@mui/material'

const SanctionsBanner = () => {
  return (
    <Alert severity="warning" variant="filled" sx={{ borderRadius: 0 }}>
      <Typography color="white">
        This applicant requires sanctions verification. Please confirm sanction status in
        Credas before verifying applicant's identity.
      </Typography>
    </Alert>
  )
}

export default SanctionsBanner
